/* @flow */
import { css } from 'linaria';

import MediaQueries from './MediaQueries';

export const RESPONSIVE_SPACER_SIZE_STYLES = {
  '15': {
    small: css`
      padding: ${15 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${15 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${15 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${15 / 2}px !important;
      }
    `,
  },
  '25': {
    small: css`
      padding: ${25 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${25 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${25 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${25 / 2}px !important;
      }
    `,
  },
  '30': {
    small: css`
      padding: ${30 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${30 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${30 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${30 / 2}px !important;
      }
    `,
  },
  '40': {
    small: css`
      padding: ${40 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${40 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${40 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${40 / 2}px !important;
      }
    `,
  },
  '50': {
    small: css`
      padding: ${50 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${50 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${50 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${50 / 2}px !important;
      }
    `,
  },
  '75': {
    small: css`
      padding: ${75 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${75 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${75 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${75 / 2}px !important;
      }
    `,
  },
  '100': {
    small: css`
      padding: ${100 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${100 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${100 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${100 / 2}px !important;
      }
    `,
  },
  '150': {
    small: css`
      padding: ${150 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${150 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${150 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${150 / 2}px !important;
      }
    `,
  },
  '200': {
    small: css`
      padding: ${200 / 2}px;
    `,
    medium: css`
      ${MediaQueries.Medium} {
        padding: ${200 / 2}px !important;
      }
    `,
    large: css`
      ${MediaQueries.Large} {
        padding: ${200 / 2}px !important;
      }
    `,
    xlarge: css`
      ${MediaQueries.XLarge} {
        padding: ${200 / 2}px !important;
      }
    `,
  },
};



// WEBPACK FOOTER //
// ./src/ui/constants/ResponsiveSpacer.js